import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';
import $http from '../services/api';
import jwt_decode from 'jwt-decode';
import { subject } from '@casl/ability';
import type { IManagementUser } from '@license-manager/types';

@Module({ namespaced: true, name: 'user' })
export default class User extends VuexModule {
  public token: string = localStorage.getItem('authtoken') || null;
  public user: IManagementUser; /* = (this.token
    ? jwt_decode(this.token)
    : null) as IManagementUser;*/

  @Mutation
  setToken(token: string) {
    if (token != null) {
      localStorage.setItem('authtoken', token);
      $http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      localStorage.removeItem('authtoken');
      $http.defaults.headers.common['Authorization'] = null;
    }

    this.token = token;
  }

  @Mutation
  setUser(token: string) {
    if (token) {
      const decoded = jwt_decode<IManagementUser>(token);
      this.user = decoded;
    } else {
      this.user = null;
    }
  }

  @Action
  setLoginData(token) {
    if (token) {
      const decoded = jwt_decode(token);
      const current_time = new Date().getTime() / 1000;
      if (current_time <= +(decoded as any).exp) {
        this.context.commit('setToken', token);
        this.context.commit('setUser', token);
        return;
      }
    }

    this.context.commit('setToken', null);
    this.context.commit('setUser', null);
  }

  @Action
  async login(payload: { email: string; password: string }) {
    try {
      const token = await $http
        .post('auth/login/', {
          email: payload.email,
          password: payload.password,
        })
        .then((req) => req.data.access_token);
      await this.context.dispatch('setLoginData', token);
    } catch (e) {
      await this.context.dispatch('setLoginData', null);
    }
  }

  @Action({ rawError: true })
  async requestNewPassword({ email, lang }: { email: string; lang: string }) {
    await $http.post('managementusers/password/startrecovery', {
      email,
      lang,
    });
  }

  @Action({ rawError: true })
  async setNewPassword({
    newpassword,
    token,
  }: {
    newpassword: string;
    token: string;
  }) {
    await $http.post('managementusers/password/setnewpassword', {
      token,
      newpassword,
    });
  }

  @Action
  async refreshJWT() {
    if (this.token) {
      try {
        const token = await $http
          .get('auth/token', {
            headers: { Authorization: `Bearer ${this.token}` },
          })
          .then((req) => req.data.access_token)
          .then((token) => this.context.dispatch('setLoginData', token))
          .catch((err) => {
            if (err.response.status !== 500) {
              throw err;
            }
          });
        /*.then(() => setTimeout(() => this.context.dispatch('refreshJWT'), 1000 * 60))*/
      } catch (e) {
        await this.context.dispatch('setLoginData', null);
        throw e;
      }
    }
  }

  @Action
  logout() {
    this.context.dispatch('setLoginData', null);
  }

  get CASLUser() {
    return subject('ManagementUser', this.user);
  }

  get loggedIn() {
    if (!this.token) {
      return false;
    }
    let decoded = this.user ?? jwt_decode(this.token);

    const current_time = new Date().getTime() / 1000;
    return current_time <= +(decoded as any).exp;
  }
}
